module.exports = __webpack_public_path__ + "static/img/icon_hza.3e21408a.png";